Ext.define('SA.data.NewProjectAttributes', {
    singleton: true,

    fetch(countryCode, facet) {
        var censusReleaseYear = SA.Institution.getCountry(countryCode).getLatestCensusRelease(),
            latestEditionPredicate = SA.data.AttributesQuery.getLatestEditionPredicate({countryCode, censusReleaseYear}),
            query = SA.data.Query.from({
                type: 'attributes',
                fields: ['attribute', 'name', 'attributeSeries'],
                limit: 99,
                sort: [['asc', 'order']],

                where: SA.data.AttributesQuery.getCountryAndStatusVisiblePredicate(countryCode).concat([
                    ['=', facet, 'true'],
                    latestEditionPredicate,
                    ['=', 'censusRelease', censusReleaseYear]
                ])
            });

        return query.run().then(() => query.response.results);
    },

    get(countryCode) {
        return this.cache[countryCode];
    },

    getAllIds() {
        return Ext.Array.flatten(Object.values(this.cache)).map(attribute => attribute.attribute);
    },

    async load(countryCode) {
        var cache = this.cache = (this.cache || {}),
            defaultsFetch = this.fetch(countryCode, 'h_new_project_defaults'),
            optionalFetch = this.fetch(countryCode, 'h_new_project_choices'),
            values = await Promise.all([defaultsFetch, optionalFetch]),
            defaults = Ext.Array.pluck(values[0], 'attribute'),
            choices = cache[countryCode] = values[1];

        choices.forEach(attribute => {
            attribute.isDefault = defaults.includes(attribute.attribute);
        });

        return choices;
    },

    async loadAll() {
        await Promise.all(SA.Institution.getCountryCodes().map(this.load, this));

        return this.getAllIds();
    }
});